import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import {
  authStorageGet,
  authStorageSet,
  authStorageRemove,
  clearAuthSessionStorage,
} from "../../utils/authStorage";

function readStoredUser() {
  try {
    const raw = authStorageGet("user");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

const initialState = {
  user: readStoredUser(),
  openedChat: null,
  closeChatModal: () => null,
  notificationCount: [],
  meetingInfo: null,
  serviceAgreement: {
    opraPdf: null,
    nasdaqPdf: null,
  },
  coinRoutes: null,
  menuBar: "left",
  platformType: "APP",
  layoutLoaded: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
      authStorageSet("token", action.payload);
    },
    clearToken: (state) => {
      state.token = null;
      authStorageRemove("token");
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    setUser: (state, action) => {
      state.user = action.payload;
      try {
        if (action.payload && typeof action.payload === "object") {
          authStorageSet("user", JSON.stringify(action.payload));
        } else {
          authStorageRemove("user");
        }
      } catch {
        // ignore storage failures
      }
    },
    signIn: (state, { payload }) => {
      authStorageSet("token", payload.token);
      const decodedToken = jwtDecode(payload.token);
      state.user = {
        ...decodedToken,
        layout: [],
      };
    },
    signOut: (state) => {
      clearAuthSessionStorage();
      state.user = null;
      state.token = null;
    },
  },
});

export const {
  signIn,
  signOut,
  setToken,
  clearToken,
  setLoading,
  setError,
  setUser,
  clearError,
} = userSlice.actions;

export default userSlice.reducer;
